<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">แก้ไขผู้ดูแลระบบ</h2>
      </div>

      <AdminForm
        @updateAdmin="updateAdmin"
        :admin="admin"
        type="update"
      />
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import AdminForm from "@/components/admin/AdminForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    AdminForm,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      adminId: "",
      admin: null,
      loading: true,
    };
  },
  mounted() {
    this.setParams();
    this.fetchAdminById();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.adminId != "undefined") {
          this.adminId = this.routeParams.adminId;
        }
      }
    },
    updateAdmin(data) {
      this.loading = true;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("userId", this.adminId);
      formData.append("email", data.email);
      formData.append("nameTH", data.nameTh);
      formData.append("surnameTH", data.lastNameTh);
      formData.append("nameEN", data.nameEn);
      formData.append("surnameEN", data.lastNameEn);
      formData.append("titleName", data.prefix);
      formData.append("countryCode", data.countryCode);
      formData.append("mobilephone", data.phoneNumber);

      if (data.password) {
        formData.append("password", data.password);
      }

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`admin`, formData, config)
        .then((res) => {

          if (res.data.success) {
            this.fetchAdminById();
            this.$message({
              message: 'แก้ไขสำเร็จแล้ว',
              type: 'success'
            });
          } else {
            this.loading = false;
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          this.loading = false;
          console.log("updateAdmin error", e);
        });
    },
    fetchAdminById() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`admin/${this.adminId}`)
        .then((res) => {

          if (res.data.success) {
            this.admin = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchAdminById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
